import { render } from "./ModalPrintTms.vue?vue&type=template&id=05f04248&scoped=true"
import script from "./ModalPrintTms.vue?vue&type=script&lang=js"
export * from "./ModalPrintTms.vue?vue&type=script&lang=js"

import "./ModalPrintTms.vue?vue&type=style&index=0&id=05f04248&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f04248"]])

export default __exports__